export const industries = [
  {
    id: "ecommerce",
    name: "E-commerce & Retail",
    icon: "ri-shopping-bag-3-line",
    tagline: "Shoppers leave the moment no one answers.",
    problems: [
      "Shoppers ask about sizes, stock or delivery and bounce when nobody replies.",
      "\u201cWhere is my order?\u201d tickets pile up and bury your small support team.",
      "Your busiest traffic hits at night, when there is no one left online.",
    ],
    solution:
      "Sofia answers product, stock and shipping questions instantly, suggests alternatives when something is out of stock, and turns idle browsers into checkouts, 24/7.",
  },
  {
    id: "professional-services",
    name: "Professional Services",
    icon: "ri-briefcase-4-line",
    tagline: "High-value enquiries go cold in your inbox.",
    problems: [
      "Big enquiries wait hours or days for a reply and shop around in the meantime.",
      "Your team burns billable hours on the same \u201cwhat do you do / how much?\u201d questions.",
      "Prospects cannot book a consultation outside your office hours.",
    ],
    solution:
      "Sofia qualifies every enquiry, explains your services and pricing in your voice, and drops confirmed consultations straight into your calendar so no lead slips away.",
  },
  {
    id: "hospitality",
    name: "Hospitality",
    icon: "ri-hotel-line",
    tagline: "Guests book elsewhere when the phone rings out.",
    problems: [
      "Guests call to check availability while staff are serving the people in front of them.",
      "Booking requests arrive by phone, email and social, and get missed in the rush.",
      "No-shows and late cancellations quietly eat into your revenue.",
    ],
    solution:
      "Sofia handles reservations, answers questions about rooms, menus and opening hours, and confirms bookings automatically, so your team stays focused on the guests on site.",
  },
];